import React from 'react';

const FloatingLabel = ({
  label,
  isFocused = false,
  hasValue = false,
  labelBg = 'bg-white dark:bg-[#282a29]',
}) => {
  if (!label) return null;

  const isFloating = isFocused || hasValue;

  return (
    <span
      className={`absolute left-2 px-1 pointer-events-none z-20 ${labelBg} transition-all duration-150 ease-out ${
        isFloating
          ? `-top-2.5 text-xs ${isFocused ? 'text-bloom-green' : 'text-gray-500 dark:text-gray-400'}`
          : 'top-1/2 -translate-y-1/2 text-sm text-gray-500'
      }`}
    >
      {label}
    </span>
  );
};

export default FloatingLabel;
